import React from "react";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';

import { ReactComponent as FooterEagle } from '../images/footer-eagle.svg'

import { ReactComponent as BlueskyIcon } from '../images/bluesky.svg'
import { ReactComponent as LinkedinIcon } from '../images/linkedin.svg'

const Footer = () =>
  <footer className="page-footer font-small">
    <Container fluid={true} className="container-fluid border-top pt-4">
        <style type="text/css">
            {`
                .footer-img > path {
                    fill: var(--bs-body-color) !important;
                }
            `}
        </style>
        <Row>
            <Col md={3} xs={6} className="text-start d-flex justify-content-center order-2 order-md-1" style={{alignItems: "center"}}>
                <FooterEagle className="footer-img" viewBox="-400 0 1600 1600" height="256px" style={{marginBottom: "-100px"}}/>
            </Col>
            <Col md={6} className="mt-md-0 my-3 text-start order-1">
                <h5>Corya.US</h5>
                <p>Corya.US is the public-facing blockchain and cryptocurrency division of Corya Enterprises, LLC. We contribute to the resiliancy of blockchain and DePIN networks through node hosting.</p>
                <div className="d-flex justify-content-center">
                    <a href="https://bsky.app/profile/coryaent.bsky.social" target="_blank" rel="noopener noreferrer" aria-label="Hive"><BlueskyIcon className="social-icon me-4" /></a>
                    <a href="https://www.linkedin.com/company/coryaent" target="_blank" rel="noopener noreferrer" aria-label="Hive"><LinkedinIcon className="social-icon me-4" /></a>
                </div>
            </Col>

            <Col md={3} xs={6} className="mt-md-0 my-3 text-start order-3">
                <h5>Hosting partners</h5>
                <ul className="list-unstyled">
                    <li><a href="https://vpshostingservice.co/aff.php?aff=2396" target="_blank" rel="noopener noreferrer">VPS Hosting Service</a></li>
                    <li><a href="https://clients.microtronix-tech.com/aff.php?aff=59" target="_blank" rel="noopener noreferrer">Microtonix ESolutions</a></li>
                    <li><a href="https://softshellweb.com/client/aff.php?aff=432" target="_blank" rel="noopener noreferrer">SoftShellWeb</a></li>
                </ul>
            </Col>
        </Row>
    </Container>

    <div className="footer-copyright text-center py-3">
        Copyright © {new Date().getFullYear()} Corya Enterprises, LLC
    </div>

  </footer>

export default Footer
